import moment from 'moment/moment'
import IndexController from './index_controller'

export default class extends IndexController {
  connect () {
    super.connect()

    $('#report-templates').dropdown({})

    const accountsDropdown = $('#accounts')
    if (accountsDropdown.length) {
      accountsDropdown.dropdown({})
    }

    super.initializeFromToDateFilters()
  }

  buildFilters () {
    const filters = super.buildFilters()
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].report_templates = $('#report-templates').dropdown('get values') || []
    if ($('#accounts').length) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].accounts = $('#accounts').dropdown('get values') || []
    }

    const fromDatePicker = $('#from-date-filter').data('datepicker')
    const toDatePicker = $('#to-date-filter').data('datepicker')

    const fromDate = fromDatePicker ? moment.utc(fromDatePicker.getDate()) : null
    const toDate = toDatePicker ? moment.utc(toDatePicker.getDate()).add(1, 'd').subtract(1, 's') : null

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date = fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date = toDate.unix()
    }

    return filters
  }

  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#report-templates').dropdown('clear')
    if ($('#accounts').length) {
      $('#accounts').dropdown('clear')
    }
    $('#reports-search-input').val('')
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()
  }

  getUrl () {
    return '/organisation-dashboard/reports'
  }
}
